import { useState } from "react";
import { toast, Zoom } from "react-toastify";
import SimulateNotificationView from "./view";
import { noop } from "@client/shared/constants";
import Service from "./service";
const SimulateNotification = ({
	accountId = "~",
	extension = "~",
	classes: passedClasses = {},
	disabled = true,
	isStatusOff = false,
	notification = {},
	handleSuccess = noop,
}) => {
	const [dialogState, setDialogState] = useState({
		simulate: false,
		simulateSuccess: false,
		simulateError: false,
		isSimulating: false,
	});

	const handleSimulateConfirmation = async () => {
		if (dialogState.isSimulating) {
			return;
		}
		toast.info("Simulating notification, please wait.", {
			autoClose: 2000,
		});
		const timeout = setTimeout(() => {
			toast.info("It is taking longer than expected, please wait.", {
				autoClose: 5000,
				transition: Zoom,
			});
		}, 6000);
		setDialogState((prevState) => ({ ...prevState, isSimulating: true }));
		// const payload =
		// 	notification && notification.voicemail_extension
		// 	? {
		// 				isTestCall: true,
		// 				notificationId: notification.id,
		// 				uuid: "ed1cf00c-0420-4bf5-a0ae-e659bb9f77e0",
		// 				event: "/restapi/v1.0/account/~/extension/823476228762/voicemail",
		// 				subscriptionId: "dc853541-66ac-45d8-a289-1a239fd72888",
		// 				ownerId: extension,
		// 				timestamp: new Date().toISOString(),
		// 				body: {
		// 					id: 82063400004,
		// 					to: [
		// 						{
		// 							name: "John Doe",
		// 						},
		// 					],
		// 					from: {
		// 						phoneNumber: "+18664320079",
		// 						name: "Jane Doe",
		// 					},
		// 					type: "VoiceMail",
		// 					creationTime: "2018-02-28T10:05:55.000Z",
		// 					readStatus: "Unread",
		// 					priority: "Normal",
		// 					attachments: [
		// 						{
		// 							id: 82063400004,
		// 							uri: "https://platform.ringcentral.com/restapi/v1.0/account/14833636004/extension/14833636004/message-store/82063400004/content/82063400004",
		// 							type: "AudioRecording",
		// 							contentType: "audio/x-wav",
		// 							vmDuration: 3,
		// 						},
		// 					],
		// 					direction: "Inbound",
		// 					availability: "Alive",
		// 					messageStatus: "Received",
		// 					lastModifiedTime: "2018-02-28T10:06:05.000Z",
		// 					vmTranscriptionStatus: "Completed",
		// 				},
		// 		  }
		// 		: {
		// 				isTestCall: true,
		// 				notificationId: notification.id,
		// 				uuid: "1060110384578023454",
		// 				event: `/restapi/v1.0/account/${accountId}/extension/${extension}/telephony/sessions`,
		// 				timestamp: new Date().toISOString(),
		// 				subscriptionId: "61111289-ceea-40ed-95ba-7e77f4ff9fc0",
		// 				ownerId: extension,
		// 				body: {
		// 					sequence: 2,
		// 					sessionId: "22771650004",
		// 					telephonySessionId: "s-0c399691185f49558c0d25add74494c2",
		// 					serverId: "10.28.20.109.TAM",
		// 					eventTime: "2020-06-19T07:23:55.239Z",
		// 					parties: [
		// 						{
		// 							accountId,
		// 							extensionId: extension,
		// 							id: "p-0c399691185f49558c0d25add74494c2-1",
		// 							direction:
		// 								notification.call_direction === "Both Directions"
		// 									? "Inbound"
		// 									: notification.call_direction,
		// 							to: {
		// 								phoneNumber: notification.external_phone_number,
		// 								extensionId: extension,
		// 								deviceId: "801556927004", //Need to figure out where to get.
		// 							},
		// 							from: {
		// 								phoneNumber: notification.external_phone_number,
		// 								extensionId: extension,
		// 								deviceId: "801556927004", //Need to figure out where to get.
		// 							},
		// 							status: {
		// 								code: "Setup",
		// 								rcc: false,
		// 							},
		// 							park: {},
		// 							missedCall: false,
		// 							standAlone: false,
		// 							muted: false,
		// 						},
		// 					],
		// 					origin: {
		// 						type: "Call",
		// 					},
		// 				},
		// 		  };
		let response =  await Service.getSimulatePayload(notification.id);
		if (response?.error) {
			toast.error(Array.isArray(response?.error) ? response?.error[0] && response?.error[0].message : response?.error);
			setDialogState((prevState) => ({
				...prevState,
				isSimulating: false,
				simulateError: true,
				simulate: false,
			}));
			return;
		}
		
		const { error } = await Service.simulate(response?.data?.simulatePayload);
		clearTimeout(timeout);
		if (error) {
			setDialogState((prevState) => ({
				...prevState,
				isSimulating: false,
				simulateError: true,
				simulate: false,
			}));
		} else {
			handleSuccess();
			setDialogState((prevState) => ({
				...prevState,
				isSimulating: false,
				simulate: false,
				simulateSuccess: true,
			}));
		}
	};
	const handleCancelSimulate = () => {
		setDialogState((prevState) => ({
			...prevState,
			simulate: false,
		}));
	};
	const handleSimulateDialog = () => {
		setDialogState((prevState) => ({
			...prevState,
			simulate: true,
		}));
	};
	const handleSimulateClose = () => {
		setDialogState((prevState) => ({
			...prevState,
			simulateError: false,
			simulateSuccess: false,
		}));
	};
	const handleSimulateSave = () => {
		setDialogState((prevState) => ({
			...prevState,
			simulateError: false,
			simulateSuccess: false,
		}));
	};
	// console.clear();
	// console.log("SIMULATE NOTIFICATION", notification);
	return (
		<>
			<SimulateNotificationView
				isSimulating={dialogState.isSimulating}
				disabled={disabled}
				notification={notification}
				handleCancelSimulate={handleCancelSimulate}
				handleSimulateConfirmation={handleSimulateConfirmation}
				simulate={dialogState.simulate}
				simulateError={dialogState.simulateError}
				simulateSuccess={dialogState.simulateSuccess}
				isStatusOff={isStatusOff}
				handleSimulateClose={handleSimulateClose}
				handleSimulateSave={handleSimulateSave}
				handleSimulateDialog={handleSimulateDialog}
			/>
		</>
	);
};

export default SimulateNotification;
